<template>
    <v-card flat :class="$style.accountValidateFeedCard">
        <template v-if="subActionTyp===null">
            <v-card-title class="justify-center"><str index="message > signup_greeting" /></v-card-title>
            <v-card-text class="title" :class="$style.accountValidateFeedContent">
                <p><str index="message > validation_check_email" /></p>
            </v-card-text>
        </template>
        
        <template v-if="subActionTyp==='signup_and_registration_program_dev_state'">
            <v-card-title class="justify-center"><str index="message > signup_greeting" /></v-card-title>        
            <v-card-text class="title" :class="$style.accountValidateFeedContent">                                  
                <p><str index="message > validation_check_email" /></p>
                <p><str index="site_registration > program_in_dev release_noti"/></p>
            </v-card-text>    
        </template>
            
        <template v-if="subActionTyp==='registration_program_dev_state'">
            <v-card-title class="justify-center"><str index="site_registration > program_added_successfully"/></v-card-title>
            <v-card-text class="title" :class="$style.accountValidateFeedContent">            
                <p><str index="site_registration > program_in_dev release_noti"/></p>
            </v-card-text>                
        </template>
                
        <v-card-actions class="justify-center" :class="$style.accontValidateFeedAction">       
            <v-btn v-if="subActionTyp===null" @click="$emit('close')" color="#1c94ec" dark style="width: 100px;">
                <str index="button > close"/>
            </v-btn>
            <v-btn v-if="subActionTyp!==null" @click="redirectHomePage" color="#1c94ec" dark style="width: auto">
                <str index="button > go_vivomap"/>
            </v-btn>            
        </v-card-actions>            
    </v-card>    
</template>

<script>
export default {
    name: "AccountValidateFeed",
    props: {
        details: {
            required: true
        },
        subActionTyp: {
            type: String,
            default: null
        }
    },     
    data: function(){
        return {
        }
    },

    methods: {
        redirectHomePage: function(){         
            return this.$router.push("/");
        }
    }
}
</script>

<style module>

.accountValidateFeedCard {
    background: transparent !important;
}

.accountValidateFeedContent {
    text-align: center;
    margin-top: 5%;
}

.accountValidateFeedContent p:first-child {
    margin-bottom: 30px;
}

.accontValidateFeedAction {
    padding-bottom: 20px !important;
}

</style>

<style>

</style>